import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { HonoraireService } from '@service/syndic/honoraire.service';
import { SyndicService } from '@service/syndic/syndic.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-honoraire-add',
  templateUrl: './honoraire-add.component.html',
  styleUrls: ['./honoraire-add.component.scss']
})
export class HonoraireAddComponent implements OnInit {
  form: FormGroup;
  submit: boolean = false;
  edit: boolean = false;
  honoraire: any;
  title: string = '';

  types = [
    { label: 'Gestion', value: 'GESTION' },
    { label: 'Travaux', value: 'TRAVAUX' },
    { label: 'Assemblée générale', value: 'AG' },
    { label: 'Contentieux', value: 'CONTENTIEUX' },
    { label: 'Autre', value: 'AUTRE' }
  ];

  periodicites = [
    { label: 'Mensuel', value: 'MENSUEL' },
    { label: 'Trimestriel', value: 'TRIMESTRIEL' },
    { label: 'Annuel', value: 'ANNUEL' },
    { label: 'Ponctuel', value: 'PONCTUEL' }
  ];

  modesCalcul = [
    { label: 'Fixe', value: 'FIXE' },
    { label: 'Pourcentage', value: 'POURCENTAGE' }
  ];

  etats = [
    { label: 'Brouillon', value: 'BROUILLON' },
    { label: 'Validé', value: 'VALIDE' },
    { label: 'Payé', value: 'PAYE' },
    { label: 'Annulé', value: 'ANNULE' }
  ];

  constructor(
    public toastr: ToastrService,
    public modal: NgbActiveModal,
    private formBuild: FormBuilder,
    private emitter: EmitterService,
    private honoraireService: HonoraireService,
    private syndicService: SyndicService
  ) {
    this.edit = this.honoraireService.edit;
    this.honoraire = this.honoraireService.getHonoraire();
    const lib = this.honoraire ? this.honoraire.libelle : '';
    this.title = (!this.edit) ? 'Ajouter un honoraire' : 'Modifier l\'honoraire ' + lib;
  }

  ngOnInit(): void {
    this.createForm();
    if (this.edit && this.honoraire) { this.setFormValue(); }
  }

  createForm(): void {
    this.form = this.formBuild.group({
      uuid: [null],
      type: ['GESTION', [Validators.required]],
      periodicite: ['MENSUEL', [Validators.required]],
      montant: [0, [Validators.required]],
      modeCalcul: ['FIXE', [Validators.required]],
      taux: [0],
      etat: ['BROUILLON'],
      libelle: [null],
      description: [null],
      dateDebut: [null],
      dateFin: [null],
      montantPaye: [0],
      trustee: [this.syndicService.getSyndic()?.uuid, [Validators.required]]
    });
  }

  setFormValue(): void {
    this.form.patchValue({
      uuid: this.honoraire.uuid,
      type: this.honoraire.type,
      periodicite: this.honoraire.periodicite,
      montant: this.honoraire.montant,
      modeCalcul: this.honoraire.modeCalcul,
      taux: this.honoraire.taux,
      etat: this.honoraire.etat,
      libelle: this.honoraire.libelle,
      description: this.honoraire.description,
      dateDebut: this.honoraire.dateDebut,
      dateFin: this.honoraire.dateFin,
      montantPaye: this.honoraire.montantPaye,
      trustee: this.honoraire.trustee?.uuid
    });
  }

  onSubmit(): void {
    this.submit = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.honoraireService.add(data).subscribe(
        (res: any) => {
          if (res?.status === 'success') {
            this.modal.close('ferme');
            if (this.edit) {
              this.emitter.event.emit({ action: 'HONORAIRE_UPDATED', payload: res?.data });
            } else {
              this.emitter.event.emit({ action: 'HONORAIRE_ADD', payload: res?.data });
            }
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        },
        (error: any) => {
          const msg = error?.error?.message || 'Une erreur est survenue';
          Swal.fire({ icon: 'error', title: 'Erreur', text: msg });
        }
      );
    }
  }

  onClose(): void { this.modal.close('ferme'); }
  get f() { return this.form.controls; }
}
